<template>
  <div class="container-fluid">
    <div class="row py-1 rounded-sm align-items-center">
      <div class="col-md-6 font-weight-bold py-1">
        <slot name="p-1">
          position 1
        </slot>
      </div>
      <div class="col-md-6 py-md-0 py-1">
        <slot name="p-2">position 2</slot>
      </div>
      <div class="col-lg-12 p-2 ">
        <slot name="p-3">position 3</slot>
      </div>
    </div>
  </div>
</template>

<script>
import mA from "../Tags/A";
import mImg from "../Tags/Img";
import {CardProps} from "./CardProps";

export default {
  name: "Card202",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps,
  },
};
</script>

<style scoped>
.content-container {
  border: 1px solid #ced4da;
}
.avatar-icon {
  width: 90px;
}
</style>
